var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VButton',{attrs:{"label":_vm.__('Increase availability'),"variant":"secondary","size":"sm"},on:{"onClick":_vm.showAvailabilityCalendar}})
}
var staticRenderFns = []

export { render, staticRenderFns }